export const isInstacartBrandEnabled = (value: string | undefined): boolean => value === 'true'

export const IS_INSTACART_BRAND = isInstacartBrandEnabled(import.meta.env.VITE_INSTACART_BRAND_ENABLED)
